import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import courseConfig from '../config/course';

const included = [
  '250 editable PSD templates',
  'Flyers, posters & event designs',
  'Product & branding mockups',
  'PSD text effects',
  'Commercial-use license',
  'Instant download access',
  'Organized folders by category',
];

const styles = {
  section: {
    padding: '100px 20px',
    background: '#ffffff',
  },
  container: {
    maxWidth: '500px',
    margin: '0 auto',
    textAlign: 'center',
  },
  heading: {
    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
    fontWeight: 800,
    color: '#0a0a0a',
    marginBottom: '60px',
  },
  card: {
    padding: '40px 32px',
    borderRadius: '20px',
    background: '#0a0a0a',
    color: '#ffffff',
    border: '1px solid rgba(8,246,84,0.15)',
  },
  label: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#a1a1aa',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '8px',
  },
  courseName: {
    fontSize: '1.4rem',
    fontWeight: 700,
    marginBottom: '24px',
  },
  price: {
    fontSize: '3rem',
    fontWeight: 800,
    marginBottom: '8px',
    color: '#08F654',
  },
  priceNote: {
    fontSize: '0.9rem',
    color: '#a1a1aa',
    marginBottom: '32px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    textAlign: 'left',
    marginBottom: '32px',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 0',
    fontSize: '0.95rem',
    color: '#d4d4d8',
  },
  button: {
    width: '100%',
    padding: '16px',
    fontSize: '18px',
    fontWeight: 800,
    color: '#000000',
    background: '#08F654',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    boxShadow: '0 4px 20px rgba(8,246,84,0.25)',
    fontFamily: 'inherit',
  },
  softwareNote: {
    marginTop: '20px',
    fontSize: '0.8rem',
    color: '#71717a',
  },
};

function Pricing({ onGetCourse }) {
  return (
    <section id="pricing" style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.heading}>Get the Full Pack</h2>
        <motion.div
          style={styles.card}
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <p style={styles.label}>One-Time Payment</p>
          <h3 style={styles.courseName}>{courseConfig.courseName}</h3>
          <p style={styles.price}>$2.99</p>
          <p style={styles.priceNote}>Pay in your local currency — 14 currencies supported</p>
          <ul style={styles.list}>
            {included.map((item, index) => (
              <li key={index} style={styles.listItem}>
                <Check size={18} color="#08F654" />
                {item}
              </li>
            ))}
          </ul>
          <motion.button
            style={styles.button}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={onGetCourse}
          >
            Download Now
          </motion.button>
          <p style={styles.softwareNote}>
            Requires Adobe Photoshop or any PSD-compatible editor
          </p>
        </motion.div>
      </div>
    </section>
  );
}

export default Pricing;
